"use strict";

// init foundation
$(document).foundation();